import { IApiRequest } from "../types";

import httpService from "./http-service";

export default function chooseRequest({ requestType }: IApiRequest): typeof httpService {
  switch (requestType) {
    case "HTTP":
      return httpService;
    default:
      return httpService;
  }
}
